//imports
import './style.scss';
import React, { useEffect, useState } from 'react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import OfferLocationCardComponent from '../OfferLocationCardComponent';
import { withTranslation } from 'react-i18next';
import TabsCarouselComponent from '../Tabs/shared/carousel/TabsCarouselComponent';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import { groupBy } from 'lodash';
//component
const OfferLocationCardListComponent = (props) => {
  const context = useSitecoreContext();
  const ListOfLocations = context?.sitecoreContext?.route?.fields?.locations;
  const shouldRenderListOfLocations = Array.isArray(ListOfLocations) && ListOfLocations.length > 0;


  const [tabItems, setTabItems] = useState(ListOfLocations);
  const { params } = props;

  const tabs = {
    fields: {
      items: [],
    },
  };
  const groupedLocations = groupBy(ListOfLocations, (item) => {
    return item?.fields?.emirate?.fields?.DropdownValue?.value;
  });
  const keys = Object?.keys(groupedLocations);
  if (!!keys && keys.length > 0) {
    keys.map((key) => {
      tabs.fields.items.push({
        name: key,
        id: key,
      });
    });
  }

  useEffect(() => {
    setTabItems(groupedLocations[keys[0]]);
  }, []);

  const tabsTitles = tabs?.fields?.items;
  const tabsTitlesLength = tabsTitles.length; //only show if we have at least one tab, they are max 2 tabs and static
  const getTabName = (item) => item?.name || '';
  const firstTabName = { id: getTabName(tabsTitles[0]), name: getTabName(tabsTitles[0]) };
  const [activeTabName, setActiveTabName] = useState(firstTabName);

  //methods
  const showData = (tab) => {
    setTabItems(groupedLocations[tab.name]);
  };
  if (!shouldRenderListOfLocations) return null;
  if (!context?.sitecoreContext?.route?.fields || !props.params) {
    return <GenericPlaceholder componentName="OfferLocationCardListComponent" />;
  }

  //return data
  return (
    <div className={clsx('OfferLocationCardList', 'add-margins', params?.Styles)}>
      <div className="content row">
        <div className={clsx('innerContent', params?.GridParameters)}>
          {tabsTitlesLength > 0 && (
            <>
              <TabsCarouselComponent
                onTabClick={(name) => {
                  setActiveTabName({ id: name, name: name });
                  showData(name);
                }}
                initialTabName={activeTabName}
                tabNames={tabsTitles?.map((item, i) => ({ id: keys[i], name: getTabName(item) }))}
                className="tabs-component-pc"
                lang={props.i18n.language}
              />
              {shouldRenderListOfLocations && <RelatedTabLocations props={props} List={tabItems} />}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const RelatedTabLocations = ({ List, props }) => {
  return List?.map((item, index) => {
    return <OfferLocationCardComponent key={index} props={props} item={item} />;
  });
};

export default withTranslation()(OfferLocationCardListComponent);
